export default function getSearchStr(string) {
  if (!string) return ''
  return string.toLowerCase().replace(/\s+/g, '')
}
